import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {Modal} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import {useDispatch} from 'react-redux';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import * as actions from '../../_redux/invoicesActions';
import can from '../../../_common/components/Permissions/can';
import {useInvoicesUIContext} from "../InvoicesUIContext";

const PopupConvertToType1 = ({cellContent}) => {
  const {formatMessage} = useIntl();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const {_id, status} = cellContent;
  const isEnabled = status === 1 && can('full', 'invoices');
  const buttonClassName = `w-100 px-4 py-2 d-flex align-items-center justify-content-between text-nowrap font-size-lg 
  ${isEnabled ? `` : `opacity-30`}`;
  const buttonOpen = formatMessage({id: 'invoices-button-convert-to-1', defaultMessage: 'Create invoice of type 1',});
  const message = formatMessage({
    id: 'invoices-popup-convert-to-1-message',
    defaultMessage: 'Should i create invoice of type 1 from {id}',
  }, {id: _id});
  const buttonConfirm = formatMessage({id: 'button-label-yes', defaultMessage: 'Confirm',});
  const buttonCancel = formatMessage({id: 'button-label-no', defaultMessage: 'Cancel'});

  const {queryParams} = useInvoicesUIContext();

  return (
    <>
      <div
        className={buttonClassName}
        onClick={() => {
          if (isEnabled) {
            handleShowModal()
          }
        }}
      >
        {buttonOpen}
        <img
          src={toAbsoluteUrl('/media/svg/Convert_brandColor.svg')}
          alt="icon" className={'w-30px h-30px ml-2'}
        />
      </div>
      <Modal show={show} onHide={handleCloseModal}>
        <Modal.Body>
          <div className={'w-100 mb-12 d-flex justify-content-center font-weight-bold font-size-lg'}>
            {message}
          </div>
          <div className="d-flex justify-content-center">
            <Button
              className="btn-secondary mx-3 btn-sm w-100px"
              onClick={handleCloseModal}
            >
              {buttonCancel}
            </Button>
            <Button
              className="btn-sm mx-3 custom-send-button w-100px"
              disabled={!isEnabled}
              onClick={() => {
                dispatch(actions.convertToType1(_id));
                setTimeout(() => {
                  dispatch(actions.getInvoices(queryParams));
                  handleCloseModal();
                }, 1500)
              }}
            >
              {buttonConfirm}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupConvertToType1;